module.exports = __webpack_public_path__ + "static/media/phone2.95a9fb1e.svg";